import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { FCM } from '@capacitor-community/fcm';
import Echo from 'laravel-echo';
import mitt from 'mitt';
import {
  deleteUserDevice,
  setUserDevice
} from '@/../vendors/appcomponents/src/API/Notifications';

window.io = require('socket.io-client');

export const pushNotifications = {
  echoServer: null,
  socketPrivateChannel: null,
  registerPushPromise: null,
  $emitter: mitt(),
  OnInit(session, { requestPushPermission = false } = {}) {
    try {
      if (requestPushPermission && Capacitor.getPlatform() !== 'web') {
        this.registerPushPromise = this.registerPush();
      }
      this.registerBroadcast(session);
    } catch (e) {
      console.error(e);
    }
  },
  async registerBroadcast(session) {
    this.echoServer = new Echo({
      broadcaster: 'socket.io',
      host: process.env?.VUE_APP_URL_SOCKET,
      auth: {
        headers: {
          session
        }
      }
      // transports: ['websocket', 'polling', 'flashsocket']
    });
  },
  async registerPush() {
    let permStatus = await PushNotifications.checkPermissions();
    if (permStatus.receive === 'prompt') {
      permStatus = await PushNotifications.requestPermissions();
    }

    if (permStatus.receive !== 'granted') {
      throw new Error('User denied permissions!');
    }
    this.addListeners();
    await PushNotifications.register();
  },
  async hasPushPermission() {
    if (Capacitor.getPlatform() === 'web') {
      return false;
    }

    try {
      const permStatus = await PushNotifications.checkPermissions();
      return permStatus.receive === 'granted';
    } catch (err) {
      console.error(err);
      return false;
    }
  },
  async addListeners() {
    PushNotifications.addListener('registrationError', (error) => {
      // eslint-disable-next-line
      console.error('Error: ' + JSON.stringify(error));
    });
  },
  addListenernReceive(done = () => {}) {
    PushNotifications.addListener(
      'pushNotificationReceived',
      async (notification) => {
        done(notification);
      }
    ).catch((e) => {
      console.error(e);
    });
  },
  async addListenerSocket(done = () => {}, ticket = 'notification.new') {
    this.$emitter.on('subscribed', () => {
      this.socketPrivateChannel?.listen(`.${ticket}`, (e) => {
        done(e);
      });
    });
  },
  async addListenerActionPerformed(done = () => {}) {
    PushNotifications.addListener(
      'pushNotificationActionPerformed',
      async (notification) => {
        const { data } = notification.notification;
        done(data);
      }
    ).catch((e) => {
      console.error(e);
    });
  },
  async subscribeTo(userId, { registerDevice = false } = {}) {
    const topic = `user${userId}`;
    const canRegisterDevice =
      Capacitor.getPlatform() !== 'web' &&
      (registerDevice || (await this.hasPushPermission()));

    if (canRegisterDevice) {
      console.log(`try subscribe to topic “${topic}”`);
      FCM.subscribeTo({ topic })
        .then(() => console.log(`subscribed to topic “${topic}”`))
        .catch((err) => console.error(err));

      this.syncCurrentDevice().catch((err) => console.error(err));
    }

    this.socketPrivateChannel = this.echoServer.private(
      `notification.user.${userId}`
    );
    this.$emitter.emit('subscribed');
  },
  async syncCurrentDevice() {
    if (Capacitor.getPlatform() === 'web') {
      return;
    }

    if (this.registerPushPromise) {
      try {
        await this.registerPushPromise;
      } finally {
        this.registerPushPromise = null;
      }
    }

    const data = await FCM.getToken();
    if (data?.token) {
      await setUserDevice(data.token, Capacitor.getPlatform());
    }
  },
  async unsubscribeFrom(userId) {
    const topic = `user${userId}`;
    FCM.unsubscribeFrom({ topic })
      .then(() => console.log(`unsubscribe from topic “${topic}”`))
      .catch((err) => console.error(err));
  },
  async deactivateCurrentDevice(userId) {
    if (Capacitor.getPlatform() === 'web') {
      return;
    }

    try {
      const data = await FCM.getToken();
      if (data?.token) {
        await deleteUserDevice(data.token, Capacitor.getPlatform());
      }
    } catch (err) {
      console.error(err);
    }

    if (userId) {
      await this.unsubscribeFrom(userId);
    }
  },
  async setReadedAllNotifications() {
    PushNotifications.removeAllDeliveredNotifications();
  }
};
